import { isServer, QueryClient } from '@tanstack/react-query';

const makeQueryClient = () => new QueryClient();

let browserQueryClient: QueryClient | undefined = undefined;

/**
 * @see https://tanstack.com/query/latest/docs/framework/react/guides/advanced-ssr
 */
const getQueryClient = () => {
    if (isServer) {
        return makeQueryClient();
    } else {
        if (!browserQueryClient) {
            console.log('Creating new query client');
            browserQueryClient = makeQueryClient();
        }
        return browserQueryClient;
    }
};

export { getQueryClient };
